import { render, staticRenderFns } from "./CriarStakeHolderTipos.vue?vue&type=template&id=f13deaba&scoped=true&"
import script from "./CriarStakeHolderTipos.vue?vue&type=script&lang=js&"
export * from "./CriarStakeHolderTipos.vue?vue&type=script&lang=js&"
import style0 from "./CriarStakeHolderTipos.vue?vue&type=style&index=0&id=f13deaba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13deaba",
  null
  
)

export default component.exports